.btn {
  :global(.ant-btn-icon) {
    line-height: 1;

    :global(.anticon) {
      font-size: var(--rc-theme-font-size-text-lg);
    }
  }

  &:global(.ant-btn-color-default.ant-btn-variant-link:not(:disabled):not(.ant-btn-disabled):hover) {
    color: var(--rc-theme-color-primary-default);
  }

  &:global(.ant-btn-color-primary.ant-btn-variant-link:not(:disabled):not(.ant-btn-disabled):hover) {
    color: var(--rc-theme-color-primary-default80);
  }

  &:global(.ant-btn-color-dangerous.ant-btn-variant-link:not(:disabled):not(.ant-btn-disabled):hover) {
    color: var(--rc-theme-color-error-default80);
  }

  &:global(.ant-btn-color-dangerous.ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover) {
    background: var(--rc-theme-color-error-default80);
  }

  &:global(.ant-btn-variant-link) {
    width: auto;
    height: max-content;
    padding: 0;
  }
}

.btn--link-inverted {
  color: var(--rc-theme-color-surface-default);

  &:global(.ant-btn-color-default.ant-btn-variant-link:not(:disabled):not(.ant-btn-disabled):hover) {
    color: color-mix(in srgb, var(--rc-theme-color-surface-default) 70%, transparent);
  }

  &:disabled {
    color: color-mix(in srgb, var(--rc-theme-color-surface-default) 50%, transparent);
  }
}

.btn--vertical {
  --icon-background-size: 32px;

  display: flex;
  flex-direction: column;
  height: 100%;
  padding: var(--rc-theme-spacing-ms);
  row-gap: var(--rc-theme-spacing-xs);

  :global(.anticon) {
    display: flex;
    justify-content: center;
    width: var(--icon-background-size);
    height: var(--icon-background-size);
    border-radius: 50%;
    background-color: var(--rc-theme-color-surface-subtle);
  }
}
